import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SocialTag } from '../common/utils/social-tags.utils';
import { TAG_LEVEL_TONAL_COLORS } from './state';
import useRelevantSocialTags, { DisplayRules } from './hooks/useRelevantSocialTags';

export interface SocialTagsProps {
  tags: SocialTag[];
  displayRules: DisplayRules;
}

export default function SocialTags({ tags, displayRules }: SocialTagsProps): React.JSX.Element {
  const { t } = useTranslation(['social-proof']);
  const displayTags = useRelevantSocialTags(tags, displayRules);

  return (
    <>
      {displayTags.map((tag) => (
        <Chip
          label={t(`social-proof:${tag.type.toLowerCase()}.title`)}
          variant="accentTag"
          color={TAG_LEVEL_TONAL_COLORS[tag.level - 1]}
          key={tag.type}
        />
      ))}
    </>
  );
}
